import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Card from '../../layout/Card';
import ModuleHome from '../../layout/ModuleHome';
import { breadcrumbsPropTypes } from '../../common/resource/proptypes/CommonPropTypes';

const DriverUnitHome = ({ cards, breadcrumbs }) => (
  <ModuleHome
    title="Gestión de Conductores"
    text="Gestión de conductores: movimientos, asignaciones, programación y tareo."
    cards={cards}
    breadcrumbs={breadcrumbs}
  />
);

const mapStateToProps = ({ TrafficUnit }) => ({
  cards: TrafficUnit.DriverUnitHome.get('cards'),
  breadcrumbs: TrafficUnit.DriverUnitHome.get('breadcrumbs'),
});

DriverUnitHome.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(Card.propTypes)).isRequired,
};

export default connect(mapStateToProps)(DriverUnitHome);